import ToolbarItem from '../../../components/GlobalToolbar/Components/ToolbarItem';
import { useAppSelector } from '../../../hooks';
import { selectScopes } from '../../../selectors';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import CallingRemote from './CallingRemote';
import { jsx as _jsx } from "react/jsx-runtime";
export const CallingToolbarIconButton = memoWithDisplayName('CallingToolbarIconButton', () => {
  const scopes = useAppSelector(selectScopes);
  const hasCallingAccess = scopes.includes('calling-access');
  if (!hasCallingAccess) {
    return null;
  }
  return /*#__PURE__*/_jsx(ToolbarItem, {
    id: "hs-global-toolbar-calling-list-item",
    render: () => /*#__PURE__*/_jsx(CallingRemote, {})
  });
});